var exports = {
  "kL": "container__5zknuE",
  "Kk": "icon__lkQV0j",
  "R_": "heading__RPwBcX",
  "VA": "subtitle__lK7SMi",
};

module.exports = exports;
